import type { VmCustomImage } from "@warrenio/api-spec/spec.oats.gen";

export const bootImagesExample: VmCustomImage[] = [
    {
        uuid: "e3a5f2d6-7d15-11f0-85ba-047bcbc1cb26",
        image_name: "systemrescue-12.x-amd64.iso",
        is_installation_media: false,
        description: "SystemRescue 12",
        is_published: true,
    },
    {
        uuid: "0bfb622b-eb99-4143-8136-23c247e74434",
        image_name: "boot-repair-disk-64bit.iso",
        is_installation_media: false,
        description: "Boot Repair",
        is_published: false,
    },
    {
        uuid: "70442ea4-0e33-4b4d-bfcd-6154cc183bf9",
        image_name: "Yeastar-P_SOFTWARE-manual-83.20.0.23-debian.iso",
        is_installation_media: true,
        description: "Yeastar-P_SOFTWARE-manual-83.20.0.23-debian",
        is_published: false,
    },
    {
        uuid: "f4dede4d-cc5a-421a-9a29-01f3a5a8617b",
        image_name: "ViciBox_V12.x86_64-12.0.2.iso",
        is_installation_media: true,
        description: "ViciBox_V12.x86_64-12.0.2",
        is_published: false,
    },
    {
        uuid: "8454ab0b-9d15-4a66-bb9e-855dadb21c7a",
        image_name: "netboot.xyz.iso",
        is_installation_media: true,
        description: "netboot.xyz",
        is_published: true,
    },
];

// cspell:words Vici Yeastar
